import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Phone, MessageCircle } from 'lucide-react';
export function LocationContact() {
  return <section className="py-24 px-6 bg-charcoal-800" data-id="element-39">
      <div className="container mx-auto max-w-6xl" data-id="element-40">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-41">
          {/* Contact Info */}
          <motion.div className="w-full lg:w-1/3 space-y-10" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-42">
            <div data-id="element-43">
              <h2 className="text-3xl font-serif text-cream mb-2" data-id="element-44">
                Encuéntranos
              </h2>
              <div className="w-12 h-[1px] bg-gold-500/50 mb-8" data-id="element-45"></div>
            </div>

            <div className="space-y-8" data-id="element-46">
              <div className="flex gap-4" data-id="element-47">
                <MapPin className="text-gold-400 shrink-0 mt-1" size={24} data-id="element-48" />
                <div data-id="element-49">
                  <h4 className="text-cream font-medium mb-1" data-id="element-50">Dirección</h4>
                  <p className="text-cream-muted font-light text-sm leading-relaxed" data-id="element-51">
                    De los bomberos de Pavas, 100 mts Oeste.
                    <br data-id="element-52" />
                    10 mts norte con Spoon.
                    <br data-id="element-53" />
                    San José, Costa Rica. 10109.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-54">
                <Clock className="text-gold-400 shrink-0 mt-1" size={24} data-id="element-55" />
                <div data-id="element-56">
                  <h4 className="text-cream font-medium mb-1" data-id="element-57">Horario</h4>
                  <p className="text-cream-muted font-light text-sm leading-relaxed" data-id="element-58">
                    Lunes: 9:00 AM - 8:00 PM
                    <br data-id="element-59" />
                    Martes a Viernes: 8:30 AM - 8:00 PM
                    <br data-id="element-60" />
                    Sábados: 8:00 AM - 8:00 PM
                    <br data-id="element-61" />
                    Domingos: Cerrado
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-62">
                <Phone className="text-gold-400 shrink-0 mt-1" size={24} data-id="element-63" />
                <div data-id="element-64">
                  <h4 className="text-cream font-medium mb-1" data-id="element-65">Contacto</h4>
                  <p className="text-cream-muted font-light text-sm leading-relaxed mb-4" data-id="element-66">
                    +506 6062 5033
                  </p>
                  <a href="https://wa.me/50660625033?text=Hola%2C%20quiero%20más%20información%20sobre%20sus%20servicios" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-6 py-3 rounded-sm font-medium transition-colors text-sm" data-id="element-67">
                    <MessageCircle size={18} data-id="element-68" />
                    Escríbenos por WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div className="w-full lg:w-2/3 h-[400px] lg:h-auto min-h-[400px] bg-charcoal-900 rounded-sm overflow-hidden border border-charcoal-700 relative" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-69">
            {/* Using a generic Google Maps embed for Pavas, San Jose */}
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15719.983637158308!2d-84.1436412!3d9.9344445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0e342c50d15c5%3A0xe6746a6a9f11b882!2sPavas%2C%20San%20Jos%C3%A9%20Province%2C%20San%20Jos%C3%A9!5e0!3m2!1sen!2scr!4v1700000000000!5m2!1sen!2scr" width="100%" height="100%" style={{
            border: 0,
            filter: 'grayscale(1) contrast(1.2) opacity(0.8)'
          }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="MA Barber Studio Location" className="absolute inset-0" data-id="element-70"></iframe>
            {/* Overlay to make map fit the dark theme better */}
            <div className="absolute inset-0 bg-charcoal-900/20 pointer-events-none mix-blend-multiply" data-id="element-71" />
          </motion.div>
        </div>
      </div>
    </section>;
}